// Configurazione globale di axios per l'applicazione

import axios from 'axios';

// Configurazione del base URL per tutte le chiamate axios
// In sviluppo, il proxy di Vite dovrebbe gestire le chiamate /api
// ma per sicurezza impostiamo comunque il backend corretto
const baseURL = import.meta.env.VITE_API_URL || import.meta.env.REACT_APP_API_URL || 'https://recupmanager.studiohard.it';

// Configurazione globale di axios
axios.defaults.baseURL = baseURL;
axios.defaults.timeout = 30000;
axios.defaults.headers.common['Content-Type'] = 'application/json';

// Interceptor per aggiungere il token di autenticazione
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor per gestire errori di autenticazione
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token scaduto o non valido
      localStorage.removeItem('authToken');
      // Solo se non siamo già sulla pagina di login
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default axios;